export enum CopyableConnectionDiscordChannelSettings {
  Embeds = "embeds",
  WebhookName = "webhookName",
  WebhookIconUrl = "webhookIconUrl",
  PlaceholderLimits = "placeholderLimits",
  Content = "content",
  ContentFormatTables = "contentFormatTables",
  ContentStripImages = "contentStripImages",
  ContentDisableImageLinkPreviews = "contentDisableImageLinkPreviews",
  Components = "components",
  ComponentsV2 = "componentsV2",
  ForumThreadTitle = "forumThreadTitle",
  ForumThreadTags = "forumThreadTags",
  placeholderFallbackSetting = "placeholderFallbackSetting",
  Filters = "filters",
  SplitOptions = "splitOptions",
  CustomPlaceholders = "customPlaceholders",
  DeliveryRateLimits = "deliveryRateLimits",
  MessageMentions = "messageMentions",
}
